<p-dialog [(visible)]="sdtmdialogVisible"
  styleClass="select-stdm-dialog"
  [focusOnShow]="false" [draggable]="false" [modal]="true" [resizable]="false"
  [closable]="false" appendTo="body">

  <ng-template #header>
    <div class="dialog-header">
      <span class="dialog-title">Select SDTM</span>
    </div>
  </ng-template>

  <div class="dialog-content">
    <div class="dialog-intro">
      <h2 class="intro-title">Choose Your SDTM Dataset</h2>
      <p class="intro-desc">Select the SDTM category and datasets to use for your workflow analysis</p>
    </div>

    <!-- Spec Selection -->
    <div class="spec-selector">
      <span class="spec-label">Select spec:</span>
      <p-treeSelect
        [options]="fileTree"
        [selectionMode]="'multiple'"
        placeholder="Choose Spec"
        [(ngModel)]="selectedNodes"
        styleClass="custom-tree-select"
      />
    </div>

    <!-- Accordion Content -->
    <div class="accordion-container">
      <p-accordion>
        @for (category of sdtmigData; track category.name) {
        <p-accordion-panel [value]="category.name">
          <p-accordion-header>
            <div class="accordion-header-content">
              <div class="header-left">
                <div class="folder-icon">
                  <i class="pi pi-folder"></i>
                </div>
                <span class="category-name">{{ category.label }}</span>
              </div>
              @if(getSelectedCount(category.name) > 0) {
                <span class="selected-badge">{{ getSelectedCount(category.name) }} selected</span>
              }
            </div>
          </p-accordion-header>
          <p-accordion-content>
            <p-accordion>
              @for (dataset of category.datasets; track dataset.name) {
              <p-accordion-panel [value]="dataset.name">
                <p-accordion-header>
                  <div class="dataset-header">
                    <p-checkBox #includeData [name]="dataset.name" [binary]="true" (click)="$event.stopPropagation()"
                      (onChange)="onDatasetCheckboxChange(category.name, dataset.name, $event.checked, true)"/>
                    <span class="dataset-name">{{ dataset.name }}</span>
                    <span class="dataset-label">({{ dataset.label }})</span>
                    @if(getSelectedCount(category.name, dataset.name) > 0) {
                      <span class="selected-count">{{ getSelectedCount(category.name, dataset.name) }} columns</span>
                    }
                  </div>
                </p-accordion-header>
                <p-accordion-content>
                  <div class="columns-selector">
                    <div class="columns-header">
                      <i class="pi pi-list"></i>
                      <span>Select Columns</span>
                    </div>
                    <p-multiselect #columnsSelection class="custom-multiselect" [options]="dataset.columns"
                      [optionLabel]="'label'" [filter]="true" [filterBy]="'label'" size="small"
                      [placeholder]="'Choose columns...'"
                      [(ngModel)]="selections[category.name][dataset.name]"
                      (onChange)="ensureDatasetSelected(category.name, dataset.name, columnsSelection.value, includeData)"
                      optionDisabled="required"
                      optionValue="name"
                      [appendTo]="'body'">
                      <ng-template pTemplate="item" let-column>
                        <div class="column-item" [class.disabled]="column.required">
                          <span class="column-name">{{ column.name }}</span>
                          <span class="column-label">({{ column.label }})</span>
                        </div>
                      </ng-template>
                    </p-multiselect>
                  </div>
                </p-accordion-content>
              </p-accordion-panel>
              }
            </p-accordion>
          </p-accordion-content>
        </p-accordion-panel>
        }
      </p-accordion>
    </div>

    <!-- Action Buttons -->
    <div class="dialog-actions">
      <button type="button" class="btn-secondary" (click)="close()">
        Cancel
      </button>
      <button type="button" class="btn-primary" (click)="onSubmitSdtm()">
        Confirm Selection
      </button>
    </div>
  </div>
</p-dialog>

<!-- USDM Dialog -->
<p-dialog [(visible)]="usdmdialogVisible"
  styleClass="select-stdm-dialog"
  [focusOnShow]="false" [draggable]="false" [modal]="true" [resizable]="false" [closable]="false" appendTo="body">

  <ng-template #header>
    <div class="dialog-header">
      <span class="dialog-title">Select USDM</span>
    </div>
  </ng-template>

  <div class="dialog-content">
    <div class="dialog-intro">
      <h2 class="intro-title">Choose Your USDM Protocol</h2>
      <p class="intro-desc">Select the USDM Protocol to use for your workflow analysis</p>
    </div>

    <!-- Protocol Selection -->
    <div class="form-section">
      <div class="form-row">
        <label class="form-label">Select Protocol:</label>
        <p-treeSelect
          [options]="fileTree"
          placeholder="Choose Protocol"
          [(ngModel)]="usdmSelectedNode"
          appendTo="body"
          styleClass="custom-tree-select">
          <ng-template pTemplate="header">
            <div class="tree-header">
              <button type="button" class="upload-btn" (click)="uploadFile.toggle(rootNode!)">
                <i class="pi pi-upload"></i>
                <span>Upload Files</span>
              </button>
            </div>
          </ng-template>
        </p-treeSelect>
      </div>

      <div class="form-row">
        <label class="form-label">OSB Study UID:</label>
        <input type="text" class="form-input" placeholder="Enter OSB Study UID" [(ngModel)]="osbStudyUid" />
      </div>

      <div class="form-row">
        <label class="form-label">OSB Server URL:</label>
        <input type="text" class="form-input" placeholder="Enter OSB Server URL" [(ngModel)]="osbServerUrl" />
        @if(osbServerUrl === environment.osburl || osbServerUrl === environment.osburl + '/') {
          <p class="form-warning">
            <i class="pi pi-exclamation-triangle"></i>
            This URL will create a public study on our OSB server.
          </p>
        }
      </div>

      <!-- Additional Config Accordion -->
      <p-accordion class="config-accordion">
        <p-accordion-panel value="0">
          <p-accordion-header>
            <span class="config-header">Additional Configuration</span>
          </p-accordion-header>
          <p-accordion-content>
            <div class="form-row">
              <label class="form-label">Select USDM Elements:</label>
              <p-multiselect #selectStates class="custom-multiselect" [options]="states" optionLabel="name" [appendTo]="'body'"
                placeholder="Select USDM Elements" optionDisabled="required" [filter]="true" (onChange)="checkStatesSelected()"
                [(ngModel)]="selectedStates" [maxSelectedLabels]="2"></p-multiselect>
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </div>

    <!-- Action Buttons -->
    <div class="dialog-actions">
      <button type="button" class="btn-secondary" (click)="close()">
        Cancel
      </button>
      <button type="button" class="btn-primary" (click)="onSubmitUsdm()">
        Confirm Selection
      </button>
    </div>
  </div>

  <app-upload-file #uploadFile [singleFileMode]="true" (fileUploaded)="onFileUploaded($event)"></app-upload-file>
</p-dialog>
